import { useCallback, useEffect, useRef, useState } from "react";
import { apiHandler } from "assets/api";
import { endpoint } from "assets/api/endpoint";
import { parseAndSetFlag, parseDate } from "utils/Utils";

const useApplicantStatusData = ({
  status,
  fromDate,
  toDate,
  authToken,
  featureFlags,
  enabled = true,
  useMakerEndpoint = true,
  version,
}) => {
  const [data, setData] = useState([]);
  const [error, setError] = useState(null);
  const [callInProgress, setCallInProgress] = useState(false);
  const requestId = useRef(0);
  const enabledV2InprocessTab = parseAndSetFlag(
      featureFlags?.enabledV2InprocessTab
    );
  const refetch = useCallback(
    async (filters = null) => {
      const finalFromDate = filters?.fromDate ?? fromDate;
      const finalToDate = filters?.toDate ?? toDate;

      if (
        !enabled ||
        (useMakerEndpoint && !featureFlags) ||
        !finalFromDate ||
        !finalToDate
      ) return;

      const currentRequestId = ++requestId.current;
      const findStatusByMaker = useMakerEndpoint && parseAndSetFlag(
        featureFlags?.applicationFindByStatusByMaker
      );
      const apiUrl = findStatusByMaker
        ? endpoint.APPLICANT_DETAILS_FIND_STATUS
        : endpoint.APPLICANT_FINDSTATUS;

      setCallInProgress(true);
      setError(null);

      try {
        const url =
        (enabledV2InprocessTab && status === "INPROCESS")
          ? `${apiUrl}${status}&from=${parseDate(finalFromDate)}&to=${parseDate(finalToDate)}&stage=${version}`
          : `${apiUrl}${status}&from=${parseDate(finalFromDate)}&to=${parseDate(finalToDate)}`;
        const result = await apiHandler({
          url: url,
          authToken,
        });

        if (currentRequestId !== requestId.current) return;

        if (result?.data?.error_code || result?.data?.user_description) {
          setError(result.data);
          return;
        }

        setData(result?.data || []);
      } finally {
        if (currentRequestId === requestId.current) {
          setCallInProgress(false);
        }
      }
    },
    [authToken, enabled, featureFlags, fromDate, status, toDate, useMakerEndpoint, version]
  );

  useEffect(() => {
    refetch();
  }, [refetch]);

  return { data, error, callInProgress, refetch };
};

export default useApplicantStatusData;
